/**
 * @file コンポーネント：フル動画ページタイムライン スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledTimeline = styled.div`
    > div:not([data-edit-language="en"]) > p {
        padding: 8px 16px;
    }
`;

export const StyledTimelineButton = styled.button`
    display: flex;
    align-items: center;
    padding: 8px;
    border: none;
    background-color: #acadae;
    color: #000000;
    font-size: 12px;

    &:disabled {
        background-color: #343a40;
    }
`;

export const StyledTimelineButtonIcon = styled.span`
    margin-right: 4px;
`;

export const StyledTimelineButtonText = styled.span``;

export const StyledTimelineEditContainer = styled.div`
    position: absolute;
    right: 16px;
    bottom: 8px;

    &[data-edit-language="en"] {
        display: flex;
        flex-direction: column;
        align-items: end;
        padding: 8px 16px;
        background-color: #25292d;
    }
`;

export const StyledTimelineEditText = styled.p`
    margin-bottom: 8px;
    color: #eed393;
`;

export const StyledTimelineList = styled.ol`
    &.is-editpage {
        padding-bottom: 44px;
    }
`;

export const StyledTimelineListItem = styled.li`
    position: relative;
    border-bottom: 1px solid #acadae;

    ${mediaQuery.sp(`
        margin-bottom: 0 !important;
    `)};

    ${mediaQuery.spWide(`
        margin-bottom: 0 !important;
    `)};

    ${mediaQuery.tablet(`
        margin-bottom: 0 !important;
    `)};
`;

export const StyledTimelineListItemMessage = styled.p`
    padding: 8px 16px;
    color: #ffffff;
    font-size: 11px;
    line-height: 16px;
`;

export const StyledTimelineLoading = styled.div`
    padding: 16px;
    background-color: #25292d;
`;
